import type { ReactNode } from 'react'

type PageHeroProps = {
  eyebrow: string
  title: ReactNode
  copy: string
  aside?: ReactNode
  tone?: 'aqua' | 'coral' | 'lime'
}

export function PageHero({ eyebrow, title, copy, aside, tone = 'aqua' }: PageHeroProps) {
  return (
    <section className={`page-hero tone-${tone}`}>
      <div className="container page-hero-grid">
        <div>
          <span className="eyebrow">{eyebrow}</span>
          <h1>{title}</h1>
          <p>{copy}</p>
        </div>
        {aside && <div className="page-hero-aside">{aside}</div>}
      </div>
    </section>
  )
}
